exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ccm-client-settings--3F-dDjUknAipcctBMGQrcA {\n  align-items: center;\n  min-width: 450px;\n}\n\n.ccm-client-settings--BDDAqAlQUtUsWNM-mfYkc {\n  justify-content: center;\n  align-items: center;\n  cursor: default;\n  width: 1.25rem;\n  height: 1.25rem;\n  border-width: 1px;\n  border-radius: 1.25rem;\n  border-color: blue;\n  background-color: blue;\n  color: white;\n  margin: 0px 5px 12px 16px;\n  font-weight: 500;\n}\n\n.ccm-client-settings--2bbjsmaEhEjw0ft9Y3sBXU {\n  margin: 0px 0px 0px 8px;\n}\n", ""]);

// exports
exports.locals = {
	"infoContainer": "ccm-client-settings--3F-dDjUknAipcctBMGQrcA",
	"infoContainer": "ccm-client-settings--3F-dDjUknAipcctBMGQrcA",
	"infoIcon": "ccm-client-settings--BDDAqAlQUtUsWNM-mfYkc",
	"infoIcon": "ccm-client-settings--BDDAqAlQUtUsWNM-mfYkc",
	"submitSyncContainer": "ccm-client-settings--2bbjsmaEhEjw0ft9Y3sBXU",
	"submitSyncContainer": "ccm-client-settings--2bbjsmaEhEjw0ft9Y3sBXU"
};